__turbopack_context__.v({
  "iconButton": "IconButton-module__0tdUCG__iconButton",
  "iconButtonHover": "IconButton-module__0tdUCG__iconButtonHover",
});
